import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import overlayFactory from "react-bootstrap-table2-overlay";
import { Row, Col, DropdownButton, Dropdown } from "react-bootstrap";
import Tooltip from "rc-tooltip";
import queryString from "app/services/queryStringService";
import _ from "lodash";
import { AiFillFileExcel, AiOutlineCopy } from "react-icons/ai";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";

import { Button } from "react-bootstrap";

import {
  getrequisition,
  approveReq,
  declineReq,
  exportRequisition,
  reactiveReq,
} from "app/services/paymentService";
import moment from "moment";
import { MdDone, MdClear, MdSearch, MdRefresh, MdEdit } from "react-icons/md";
import EditReq from "./EditReq";
import config from "config.json";
import { NotificationManager } from "react-notifications";
import usePagePermission from "app/hooks/usePagePermission";
import HandyScroll from "app/common/Scroll";
const { dateFormat } = config;

const AllReq = () => {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();
  // console.log({ canAdd, canView, canEdit, canDelete });

  const [filterData, setFilterData] = useState({
    FromDate: "",
    ToDate: "",
    status: "Pending",
    ReqId: 0,
    RequisitionType: "",
  });
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(filterData.FromDate);
  const [toDate, setToDate] = useState(filterData.ToDate);
  const [reqId, setReqId] = useState(filterData.ReqId);
  const [status, setStatus] = useState("Pending");
  const [requisitionType, setRequisitionType] = useState(
    filterData.RequisitionType
  );
  const [showEditReq, setShowEditReq] = useState(false);
  const [isRefreshed, setIsRefreshed] = useState(false);
  const transactionAmountFormatter = (cell, row) => {
    return <span style={{ fontWeight: "bold" }}> ₹ {row.amount} </span>;
  };
  const transactionModeFormatter = (cell, row) => {
    return <span>{row.transferMethod?.toUpperCase()} </span>;
  };
  // const refFormatter = (cell, row) => {
  //   return <span style={{ fontWeight: "bold" }}>{row.referenceNo} </span>;
  // };
  const dateFormater = (cell, row) => {
    if (cell) {
      return (
        new moment(cell).format(dateFormat) +
        "  " +
        moment(row.systemDate).format("HH:mm a")
      );
    }
  };
  const tooltipFormatter = (cell, row) => {
    return (
      <div style={{ fontWeight: "bold" }}>
        {cell?.length > 15 ? (
          <>
            <Tooltip
              placement="top"
              overlay={<div style={{ maxWidth: 250 }}>{cell}</div>}
            >
              <span style={{ whiteSpace: "nowrap" }}>
                {cell.substring(0, 10)}...{" "}
                <AiOutlineCopy
                  cursor={"pointer"}
                  className="ml-1"
                  onClick={async () => {
                    if ("clipboard" in navigator) {
                      await navigator.clipboard.writeText(cell);
                      NotificationManager.Success(
                        "Copied successfully ",
                        "Success",
                        5000
                      );
                    }
                  }}
                />
              </span>
            </Tooltip>
          </>
        ) : (
          cell
        )}
      </div>
    );
  };

  const editReqHandler = (row) => {
    setReqId(row.id);
    setShowEditReq(true);
  };
  const reactiveHandler = (row) => {
    Swal.fire({
      // title: `<h6>Do you want to reactivate Requisition?</h6>`,

      html: `<input type="hidden" id="hdnReactiveId" name="hdnReqId" value=${row.id}> `,

      showCancelButton: true,
      confirmButtonText: "Active",
      cancelButtonText: "Back",
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      icon: "question",
      title: "Do you want to reactivate requisition?",
      preConfirm: async () => {
        const data = {
          id: document.getElementById("hdnReactiveId").value,
        };
        const res = await reactiveReq(data);
        return res;
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (result.value.status == "Success") {
          Swal.fire({
            icon: "success",
            text: "Requisition approved successfully",
          });
          await loadTransaction();
        } else {
          Swal.fire({
            icon: "error",
            text: "Requisition failed",
          });
        }
      }
    });
  };

  var a = [
    "",
    "one ",
    "two ",
    "three ",
    "four ",
    "five ",
    "six ",
    "seven ",
    "eight ",
    "nine ",
    "ten ",
    "eleven ",
    "twelve ",
    "thirteen ",
    "fourteen ",
    "fifteen ",
    "sixteen ",
    "seventeen ",
    "eighteen ",
    "nineteen ",
  ];
  var b = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  function inWords(num) {
    if ((num = num.toString()).length > 9) return "overflow";
    let n = ("000000000" + num)
      .substr(-9)
      .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return;
    var str = "";
    str +=
      n[1] != 0
        ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "crore "
        : "";
    str +=
      n[2] != 0
        ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "lakh "
        : "";
    str +=
      n[3] != 0
        ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "thousand "
        : "";
    str +=
      n[4] != 0
        ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "hundred "
        : "";
    str +=
      n[5] != 0
        ? (str != "" ? "and " : "") +
          (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) +
          "only "
        : "";
    return str;
  }

  const actionFormatter = (cell, row) => {
    // console.log(row);
    if (row.status == "Pending") {
      return (
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#editReqPopup"
            onClick={() => editReqHandler(row)}
          >
            <MdEdit className="text-success mr-20" size={15}></MdEdit>
            Edit
          </Dropdown.Item>

          <Dropdown.Item
            href="#"
            onClick={() => {
              Swal.fire({
                title: `<h1>Approve Requisition</h1>`,

                html: `<h2> Balance: ${new Intl.NumberFormat(
                  "en-IN",
                  {}
                ).format(row?.amount)} </h2>
                
                <h5>( ${inWords(row?.amount)} Rupees only )</h5>
                
                
                
                <h4><b> Ref No - ${
                  row?.pgType == "CREDIT"
                    ? row?.transactionId
                    : row?.referenceNo
                }</b></h4> <h6> Username - ${
                  row.fromMember.uniqueIdentity
                } </h6> <h6>  Company - ${
                  row.fromMember.company
                }</h6>   <input type="hidden" id="hdnReqId" name="hdnReqId" value=${
                  row.id
                }> 
                                  
                        <textarea style="height:100px;resize:none;display: block;
                        margin-left: auto;
                        margin-right: auto;
                        width: 80%;
                         id="Reqremarkid" name="Reqremarkid" placeholder="Remark ..." class="swal2-input form-control"></textarea>
                        ${
                          row.pgType != "CREDIT"
                            ? `<input type="checkbox" className="form-check-input" id="ReqcreditSettle" name="ReqcreditSettle" checked> <label className="form-check-label" htmlFor="#creditSettle"> Credit Settlement</label>`
                            : ""
                        }
                       
                        
                      </div>`,

                showCancelButton: true,
                confirmButtonText: "Approve",
                cancelButtonText: "Back",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                preConfirm: async () => {
                  const data = {
                    requisitionId: document.getElementById("hdnReqId").value,
                    remark: document.getElementById("Reqremarkid")?.value,
                    creditSettlement: document.getElementById("ReqcreditSettle")
                      ? document.getElementById("ReqcreditSettle").checked
                      : false,
                  };

                  const res = await approveReq(data);
                  return res;
                },
              }).then(async (result) => {
                if (result.isConfirmed) {
                  if (result.value.status == "Success") {
                    Swal.fire({
                      icon: "success",
                      text: "Requisition approved successfully",
                    });
                    await loadTransaction();
                  } else {
                    Swal.fire({
                      icon: "error",
                      text: "Requisition failed",
                    });
                  }
                }
              });
            }}
          >
            <MdDone className="text-success mr-4" size={15}></MdDone>
            Appove
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              Swal.fire({
                title: `Decline Requisition `,
                html: `<h1>Decline Requisition </h1>`,

                html: ` <h2> Balance: ${row.amount} </h2>  <h5>( ${inWords(
                  row.amount
                )} Rupees only )</h5>  <h6> Username - ${
                  row.fromMember.uniqueIdentity
                } </h6> <h6>  Company - ${row.fromMember.company}</h6> 
                <input type="hidden" id="declineMemberId" value="${row.id}" />
                <textarea style="height:100px;resize:none;display: block;
                margin-left: auto;
                margin-right: auto;
                width: 80%"; id="declineremark" placeholder="Remark ..." class="swal2-input form-control"></textarea>`,

                showCancelButton: true,
                confirmButtonText: "Decline",
                cancelButtonText: "Back",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                preConfirm: async () => {
                  const data = {
                    requisitionId:
                      document.getElementById("declineMemberId").value,
                    remark: document.getElementById("declineremark").value,
                  };
                  const res = await declineReq(data);
                  return res;
                },
              }).then(async (result) => {
                if (result.isConfirmed) {
                  if (result.value.status === "Success") {
                    Swal.fire({
                      title: result.value.message,
                      text: "Requisition Declined successfully",
                      icon: "success",
                    });
                    await loadTransaction();
                  } else {
                    Swal.fire("Error occured");
                  }
                }
              });
            }}
          >
            <MdClear size={15} className="text-danger mr-4"></MdClear>
            Decline
          </Dropdown.Item>
        </DropdownButton>
      );
    } else if (row.status == "Declined") {
      return <Button onClick={() => reactiveHandler(row)}> Reactive</Button>;
    }
  };
  const columns = [
    {
      dataField: "memId",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
    {
      dataField: "fromMember.uniqueIdentity",
      text: "Username",

      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "fromMember.company",
      text: "Company",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    // {
    //   dataField: "transactionId",
    //   text: "Transaction Id",
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "150px", textAlign: "center" };
    //   },
    //   formatter: tooltipFormatter,
    // },
    {
      dataField: "requestDate",
      text: "Req Date",
      formatter: dateFormater,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    // {
    //   dataField: "approveDate",
    //   text: "Approval Date",
    //   formatter: dateFormater,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "150px", textAlign: "center" };
    //   },
    // },
    {
      dataField: "bankName",
      text: "Bank",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "pgType",
      text: "Req Type",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transferMethod",
      text: "Payment Mode",
      formatter: transactionModeFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "referenceNo",
      text: "Ref. Number",
      formatter: tooltipFormatter,

      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: transactionAmountFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },

    {
      dataField: "status",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "remark",
      text: "Remarks",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    // {
    //   dataField: "remark",
    //   text: "Remark",
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "150px", textAlign: "center" };
    //   },
    // },
  ];
  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };
  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadTransaction = async () => {
    const state = {
      pageNumber: page,
      pageSize: sizePerPage,
      FromDate: fromDate,
      ToDate: toDate,
      status,
      RequisitionType: requisitionType,
    };
    const query = queryString.getQueryStringFromObj(state);

    if (dataCount !== 0) {
      setLoading(true);
    }
    const response = await getrequisition(query);
    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setLoading(false);
    setData(data);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
  };

  useEffect(() => {
    loadTransaction();
  }, [page, sizePerPage, fromDate, toDate, status, requisitionType]);

  const refreshFilter = async () => {
    setFromDate(filterData.FromDate);
    setToDate(filterData.ToDate);
    setStatus("Pending");
    setRequisitionType(filterData.RequisitionType);
    setIsRefreshed(true);
  };
  useEffect(() => {
    if (isRefreshed) {
      loadTransaction();
    }
  }, [isRefreshed]);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };
  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setIsRefreshed(false);
    setTimeout(async () => {
      await loadTransaction();
    }, 10);
  };

  const exportAllReq = async () => {
    const query = queryString.getQueryStringFromObj({
      FromDate: fromDate,
      ToDate: toDate,
      status: status,
      RequisitionType: requisitionType,
    });
    if (dataCount != 0) {
      setLoading(true);
    }

    const response = await exportRequisition(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${moment().toISOString()}_requisition.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setLoading(false);
  };
  const handleExport = async () => {
    setPage(page);
    setSizePerPage(sizePerPage);

    setTimeout(async () => {
      await exportAllReq();
    }, 10);
  };

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    if (name === "FromDate") setFromDate(value);
    if (name === "ToDate") setToDate(value);
    if (name === "RequisitionType") setRequisitionType(value);
    if (name === "status") setStatus(value);
  };
  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size </label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>All Requisition</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "All Requisition" }]}></Breadcrumb>

      <div className="card card-body rounded border mb-2">
        <div className="row">
          <div className="col-md-2">
            <div className="form-group">
              <label> Transaction Status</label>
            </div>
            <select
              className="form-control"
              placeholder="Transaction Status"
              name="status"
              value={status}
              onChange={handleSearchChanges}
            >
              <option value="">All</option>
              <option value="Pending">Pending</option>
              <option value="Approved">Approve</option>
              <option value="Declined">Decline</option>
            </select>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label> Transaction Mode</label>
            </div>
            <select
              className="form-control"
              placeholder="Transaction Type"
              name="RequisitionType"
              value={requisitionType}
              onChange={handleSearchChanges}
            >
              <option value="">All</option>
              <option value="CREDIT">Credit</option>
              <option value="NORMAL">Normal</option>
            </select>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label> Date From</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="FromDate"
              value={fromDate}
              onChange={handleSearchChanges}
              max={moment().format("YYYY-MM-DD")}
            />
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label> Date To</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="ToDate"
              value={toDate}
              onChange={handleSearchChanges}
              max={moment().format("YYYY-MM-DD")}
            />
          </div>

          <div
            className="col d-flex justify-content-around"
            style={{ marginTop: "3%" }}
          >
            <button className="btn btn-outline-primary" onClick={handleSearch}>
              <MdSearch className="mx-2" size={18} />
            </button>
            <Button
              id="btn"
              className="btn btn-primary mx-1"
              onClick={refreshFilter}
            >
              Refresh
            </Button>

            <Button
              variant="outline-primary"
              onClick={handleExport}
              disabled={!dataCount}
            >
              Export
              <AiFillFileExcel className=" ms-2" />
            </Button>
          </div>
        </div>
      </div>

      <HandyScroll>
        <div style={{ overflow: "auto" }}>
          <BootstrapTable
            hover
            remote
            keyField="uniqueIdentity"
            data={data}
            columns={
              canEdit ? columns : columns.filter((x) => x.text !== "Action")
            }
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            loading={loading}
            // overlay={overlayFactory({
            //   spinner: true,
            //   styles: {
            //     overlay: (base) => ({
            //       ...base,
            //       background: "rgba(120, 120, 120, 0.5)",
            //       zIndex: "1",
            //     }),
            //   },
            // })}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>
      <EditReq
        ReqId={reqId}
        showEditReq={showEditReq}
        loadTransaction={loadTransaction}
      />
    </>
  );
};

export default AllReq;
